// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Version_container__36CLN {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n  font-size: 1.5rem;\n  margin: 20dvh 0;\n}\n\n.Version_logo__2aJ9i{\n  width: 100px;\n  height: 100px;\n}\n\n.Version_version__1q4vU{\n  display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      width: 338px;\n}\n\nul{\n  list-style: none;\n  padding: 0;\n}", ""]);
// Exports
exports.locals = {
	"container": "Version_container__36CLN",
	"logo": "Version_logo__2aJ9i",
	"version": "Version_version__1q4vU"
};
module.exports = exports;
